import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import './Dashboard.css';
import './Setup.css';

function VerifyOtp({ email, onBackToLogin }) {
  const { applySession } = useAuth();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [resending, setResending] = useState(false);

  const handleVerify = (e) => {
    e.preventDefault();
    setError(null);
    setInfo(null);
    setSubmitting(true);
    api
      .post('/auth/verify-otp', { email, otp })
      .then((res) => applySession(res.data.access_token, res.data.user))
      .catch((err) => setError(err.response?.data?.detail || 'Verification failed'))
      .finally(() => setSubmitting(false));
  };

  const handleResend = () => {
    setError(null);
    setInfo(null);
    setResending(true);
    api
      .post('/auth/resend-otp', { email })
      .then((res) => setInfo(res.data.message))
      .catch((err) => setError(err.response?.data?.detail || 'Could not resend code'))
      .finally(() => setResending(false));
  };

  return (
    <div className="setup-page">
      <div className="setup-card">
        <div className="setup-brand">
          KROSI<span>FIN</span>
        </div>
        <div className="setup-brand-sub">by NeedCFO</div>
        <h1 className="setup-title">Verify your email</h1>
        <p className="setup-subtitle">
          We sent a 6-digit code to <strong>{email}</strong>. Enter it below to activate your account.
        </p>

        {error && <p className="dash-error">{error}</p>}
        {info && <p style={{ color: '#059669', fontSize: 13, fontWeight: 600 }}>{info}</p>}

        <form onSubmit={handleVerify}>
          <div className="field-group">
            <span className="field-label">Verification Code</span>
            <input
              className="field-input"
              inputMode="numeric"
              pattern="[0-9]{6}"
              maxLength={6}
              required
              autoFocus
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
              style={{ letterSpacing: 4, fontSize: 18, textAlign: 'center' }}
            />
          </div>

          <div className="dash-btn-row">
            <button className="dash-btn dash-btn-orange" type="submit" disabled={submitting || otp.length !== 6}>
              {submitting ? 'Verifying...' : 'Verify & Continue'}
            </button>
          </div>
        </form>

        <p className="setup-subtitle" style={{ marginTop: 16 }}>
          Didn't get a code?{' '}
          <button type="button" className="setup-link-btn" onClick={handleResend} disabled={resending}>
            {resending ? 'Sending...' : 'Resend code'}
          </button>
        </p>

        <p className="setup-subtitle">
          <button type="button" className="setup-link-btn" onClick={onBackToLogin}>
            Back to sign in
          </button>
        </p>
      </div>
    </div>
  );
}

export default VerifyOtp;
